<template>
  <div class="box-second">
      <p class="title-crumb">
          <el-breadcrumb separator-class="el-icon-arrow-right color3">
              <el-breadcrumb-item>项目配置</el-breadcrumb-item>
              <el-breadcrumb-item>网管人员</el-breadcrumb-item>
          </el-breadcrumb>
      </p>
      <div class="main">
          <div class="main-left">
              <el-tree :data="dataTree" ref="tree" :props="defaultProps" @node-click="handleNodeClick" node-key='id' highlight-current default-expand-all></el-tree>
          </div>
          <div class="main-table">
              <div class="table-head">
                <div style="width:100%;display:flex;align-items:center;">
                  <span>姓名：</span>
                  <div style="width:12vw;">
                    <el-input placeholder="请输入姓名" v-model="search.personName"></el-input>
                  </div>
                  <span style="margin-left:1vw;">手机号码：</span>
                  <div style="width:12vw;">
                    <el-input placeholder="请输入手机号码" v-model="search.phone"></el-input>
                  </div>
                  <el-button type="primary" style="margin-left:1vw;" icon="el-icon-search" @click="doFilter">查询</el-button>
                  <el-button type="primary" style="margin-left:1vw;" class="add-user" @click="peosomExport">人员添加</el-button>                                
                </div>   
            
              </div>
              <div class="table-box">
                <el-table
                :data="listData"
                border
                height="100%"
                style="width: 100%;"
              >
                <template slot="empty">
                  <p>{{dataText}}</p>
                </template>
                <el-table-column
                  type="index"
                  label="序号"
                  width="60">
                </el-table-column>
                <el-table-column label="姓名">
                  <template slot-scope="scope">
                    <a>{{ scope.row.personName}}</a>
                  </template>
                </el-table-column>     
                <el-table-column label="手机号码">
                  <template slot-scope="scope">
                    <span>{{ scope.row.phone }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="部门">
                  <template slot-scope="scope">
                    <span>{{ scope.row.officeName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="岗位">
                  <template slot-scope="scope">
                    <span>{{ scope.row.positionName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.outFlag=='0'" style="color:#86A0F3">在职</span>
                    <span v-else style="color:#FF5722;">离职</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="300">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <!-- <el-button v-if="scope.row.state=='1'" size="mini" type="danger" @click="quitFun(0,scope.row)">离职</el-button>
                    <el-button v-else size="mini" type="success" @click="quitFun(1,scope.row)">入职</el-button> -->
                    <!-- <el-button size="mini" type="primary" @click="handleAutor(scope.$index, scope.row)">角色</el-button> -->
                    <el-button v-if="scope.row.state!='1'" size="mini" type="danger" @click="delPerson(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页展示 -->
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100, 200]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="totalItems"
                  style="padding-top:10px;"
              ></el-pagination>             
              </div>
          </div>
            <!-- 新增窗口 -->
    <el-dialog
    :title="dialogTitle"
    :visible.sync="addFormVisible"
    center
    width="500px"
    append-to-body
    class="add-form"
  >
    <el-form :model="addForm" :rules="rules" label-width="120px" ref="addForm">
      <el-form-item label="手机号码" prop="phone">
        <el-input v-if="addForm.id==''" v-model="addForm.phone" ></el-input>
        <el-input v-else v-model="addForm.phone" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="addForm.name"></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="addForm.idCard"></el-input>
      </el-form-item>
      <el-form-item label="组织机构">
        <el-cascader
          :options="offices"
          v-model="officeIds"
          :props="{ checkStrictly: true,label:'name',children:'treeList', value: 'id' }"
          clearable>
        </el-cascader>
      </el-form-item>
      <el-form-item label="岗位">
        <el-select v-model="addForm.position" placeholder="请选择" clearable filterable>
          <el-option v-for="item in jobsList" :key="item.value" :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否在职" v-if="addForm.id!=''">
        <el-radio-group v-model="addForm.outFlag">
          <el-radio  label="0">在职</el-radio>
          <el-radio label="1">离职</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="indexA === 2" label="权限选择：" prop="list">
        <el-checkbox-group v-model="addForm.list">
          <el-checkbox v-for="item in authList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="addFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
    </div>
  </el-dialog>
  <!-- 人员授权 -->
  <el-dialog
    width="40%"
    title="管理授权"
    :append-to-body="true"
    :lock-scroll="false"
    :visible.sync="authVisible"
    >
    <el-form ref="auth" :model="auth" label-width="120px" :rules="rulesAuth">
      <el-form-item label="活动名称：">
        <el-input v-model="auth.name" readonly style="width: 200px;"></el-input>
      </el-form-item>
      <el-form-item label="权限选择：">
        <el-checkbox-group v-model="auth.list">
          <el-checkbox v-for="item in authList" :key="item.id" :label="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="authVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbitAuth('auth')">确 定</el-button>
    </div>
  </el-dialog>
      </div>
  </div>
</template>
<script>
  import myHttp from "../../untils/port.js";
  import util from "../../untils/util.js"
  import base from '../../untils/base'
  export default {
    data() {
      var validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入手机号码'));
        } else if(!(/^1[3456789]\d{9}$/.test(value))){
          callback(new Error('请输入正确的手机号码'));
        }else {
          callback();
        }
      };
      return {
        search:{  //查询
          phone:'',
          personName:'',
          projectId:'',
          officeId:''
        },
        listData:[], //表格数据
        addForm:{
          projectId:'',
          id:'',
          position: '',
          outFlag: 0,
          name:'',
          phone:'',
          officeId:'',
          list:[],
          idCard: ''

        },
        dialogTitle:'',
        addFormVisible:false,
        dataTree:[],//左侧班组树形结构
        defaultProps:{
          label: 'name',
          children:'treeList'
        },
        rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          phone: [
            { required: true, message: '请输入手机号码', trigger: 'blur' },
            { validator: validatePhone, trigger: 'blur' }
          ],
          // list:[
          //   {type: 'array', required: true, message: '请选择角色', trigger: 'change' }
          // ]
        },
        authVisible:false,//授权弹出框
        auth:{
          list:[],   //授权列表
          name:'',
          phone:'',
        },
        authList:[],//权限列表
        rulesAuth:{
          phone:[
            { required: true, message: '请输入手机号码', trigger: 'change' }
          ]
        },
        dataText:'数据加载中...',
        projectId:'',
        unitList:[],
        postList:[],
        unitListSearch:[],
        postListSearch:[],
        currentPage: 1, // 表单列表默认页
        pageSize: 20, // 表单列表默认显示数
        totalItems: 0, // 表单列表全部长度
        curKey:'',
        userId:util.session.get('user').id,
        //组织机构
        offices:[],
        officeIds:[],//选中的组织机构
        //岗位列表
        jobsList:[],
        indexA:1
      }
    },
    mounted(){
      this.projectId = util.session.get('groupId')
      this.search.projectId = this.projectId;
      this.getTree()
      this.getJobsList()
    },
    methods: {
      /***
       * 获取侧边树
       */
      getTree(){
        var that = this
        myHttp.findProjectOfficeTreeList({
            projectId: this.projectId,
            name: ''
        }).then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.officeTreeList || []
            list = util.common.listToTree('id','parentId',list)
            var obj = [{ name: '全部', groupId: '0',  treeList: [] }]
            obj[0].treeList = list
            that.dataTree = obj
            that.offices = list
            that.curKey = 0
            that.getData()
            setTimeout(function(){
              that.$refs.tree.setCurrentKey(that.curKey)
            },100)
          }
        })
      },
      //点击树
      handleNodeClick(data,node){
        this.search.officeId = data.id
        this.currentPage = 1
        this.getData()
      },
      //获取岗位列表
      getJobsList(){
        myHttp.getDictByType({
          type:'project_user_position_type'
        }).then(resp=>{
          if(resp.data.code==200){
            var list = resp.data.data.dictList||[]
            this.jobsList = list
          }
        })
      },
      // 搜索数据
      doFilter() {
        this.getData()
      },
      // 获取数据
      getData() {
        var that = this; 
        this.search.pageNum=this.currentPage
        this.search.pageSize=this.pageSize
        myHttp.findProjectUserPage(this.search).then(function(resp){
          if(resp.data.code=="200"){
              var list = resp.data.data.projectUserPage.list||[];
              that.listData = list;
              if(that.listData.length==0){
                  that.dataText = "暂无数据"
              }
            that.totalItems =  resp.data.data.projectUserPage.total
          }else{
            that.$message.error(resp.data.msg);
            that.dataText = "暂无数据"
          }
        },function(){});
      },
      //人员添加
      peosomExport(){
        this.indexA = 1
        this.dialogTitle = "添加人员信息";
        this.addFormVisible = true;
        this.addForm.projectId = this.projectId
        // this.addForm.roleIds = []
        this.addForm.id = ''
        // this.addForm.currUserId = ''
        this.addForm.name = ''
        // this.addForm.jobsType = ''
        this.addForm.phone = ''
        // this.addForm.idCard = ''
        // this.addForm.state = '1'
        this.addForm.officeId = ''
        this.addForm.outFlag = 0
        this.addForm.position = ''
        this.addForm.idCard = ''
        // this.addForm.isChairman = '0'
        delete this.addForm.list
        this.getAllRole(false)
      },
      //修改
      handleEdit(index,row){
        this.indexA = 2
        this.dialogTitle = "修改人员信息";
        this.addFormVisible = true;
        this.addForm.id = row.id;
        // this.addForm.currUserId = row.currUserId
        this.addForm.name = row.personName;
        this.addForm.roleIds = '';
        this.addForm.phone = row.phone;
        this.addForm.idCard = row.idcard
        this.addForm.officeId = row.officeId;
        this.addForm.outFlag = row.outFlag
        this.addForm.position = row.position;
        this.addForm.projectId = row.projectId
        this.officeIds = this.addForm.officeId? this.findParents(this.addForm.officeId,'id',this.offices).reverse():''
        this.getAllRole(true,row)
      },
      //保存
      sumbitAddRow(formName){
        var that = this;
        this.$refs[formName].validate((valid) => {
            if (valid) {
              this.addForm.officeId = this.officeIds.length>0?this.officeIds[this.officeIds.length-1]:''
              if(that.addForm.id==''){
                delete that.addForm.oldRoleIds
                delete that.addForm.list
                myHttp.addProjectUser(that.addForm).then(function(resp){
                  if(resp.data.code=="200"){
                    that.$message.success('添加人员成功');
                    that.addFormVisible = false;
                    that.getData();
                  }else{
                    that.$message.error(resp.data.msg);
                  }
                });
              }else{
                that.addForm.roleIds = that.addForm.list.join(',');
                console.log(that.addForm.roleIds)
                that.addForm.currUserId = 
                myHttp.editProjectUser(that.addForm).then(function(resp){
                  if(resp.data.code=="200"){
                    that.$message.success('修改人员成功');
                    that.addFormVisible = false;
                    that.getData();
                  }else{
                    that.$message.error(resp.data.msg);
                  }
                });
              }
            }
        });
      },
      //根据手机号获取信息
      getInfoByPhone(phone){
        //console.log(phone);
        if(phone=='')return;
        var that = this;
        myHttp.getInfoByPhone({
          phone:phone
        }).then(function(resp){
          if(resp.data.code=="200"){
            var data = resp.data.data.person;
            if(data&&data.id&&''!=data.id){
              that.addForm.id = data.id;
              that.addForm.name = data.name;
              that.addForm.phone = data.phone;
            }
          }
        });
      },
      //获取角色信息
      getAllRole(flag,row){
        var that = this;
        //myHttp.getRoleListByGroupId({
        myHttp.getRoleByGroup({
          groupId:this.projectId,
          userType: util.session.get('roleId'),
          userId:util.session.get('user').id
        }).then(function(resp){
          if(resp.data.code=="200"){
            var list = resp.data.data.role||[];
            console.log(list,'000000')
            that.authList = list;
            if(flag){
              console.log(row,'10000000')
              that.getWorkerAuth(row.userId);
            }
          }else{
            that.$message.error(resp.data.msg);
          }
        });
      },
      //人员授权
      handleAutor(index,row){
        this.authVisible = true;
        this.auth.name = row.personName;
        this.auth.phone = row.phone;
        this.auth.personId = row.personId;
        this.auth.list = [];
        // this.getAllRole(true,row)
      },
      //获取当然人员的权限
      getWorkerAuth(id){
        var that = this;
        myHttp.getRoleListByUserId({
          userId:id,
          userType:util.session.get('roleId'),
          groupId:this.projectId
        }).then(function(resp){
          console.log(resp,'777')
          if(resp.data.code==200){
            console.log(resp)
            var list = resp.data.data.roleList||[];
            console.log(list,'999999999')
            var list1 = [];
            for(var i=0;i<list.length;i++){
              list1.push(list[i].id);
            }
            console.log(list1)
            that.addForm.list = list1;
            that.addForm.oldRoleIds = list1.join(',');
            // that.auth.list = list1;
          }
        });
      },
      //授权保存
      sumbitAuth(formName){
        var that = this;
        this.$refs[formName].validate((valid) => {
            if (valid) {
              var option = {};
              option.groupId = that.search.entId;
              option.userType = util.session.get('roleId');
              option.roleIds = that.auth.list.length>0?that.auth.list.join(','):'';
              option.phone = that.auth.phone;
              option.name = that.auth.name;
              option.createBy = util.session.get('user').id;
              myHttp.authorizePerson(option).then(function(resp){
                if(resp.data.code=="200"){
                  that.authVisible = false;
                  that.$message.success('授权成功');
                  that.getData();
                }else{
                  that.$message.error(resp.data.msg);
                }
              });
            }
          });
      },
      //离职或者在职
      quitFun(sta,row){
        var that = this
        myHttp.updateEntPerson1({
          id:row.id,
          currUserId:row.currUserId,
          entId:this.groupId,
          name:row.personName,
          phone:row.phone,
          isChairman:row.isChairman||'0',
          state:sta
        }).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('操作成功')
            that.getData()
          }else{
            that.$message.error('操作失败')
          }
        })
      },
        //监听供应商下拉框清空
        floorClear() {
          this.unitList = []
          this.postList = []
          this.addForm.sectionId = ''
          this.addForm.postId = ''
          this.doFilter()
        },
        floorClear1() {
          this.unitListSearch = []
          this.postListSearch = []
          this.search.unitId = ''
          this.search.postId = ''
          this.doFilter()
        },
        handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getData()
      },
      // 监控当前页码
      currentChangePage() {
        this.getData()
      },
      change(e){
        
      },

      //删除人员
      delPerson(row){
        var that = this
        myHttp.deleteProProjectUserLogic({
          id:row.id,
          phone: row.phone
          // updateBy:util.session.get('user').id
        }).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('操作成功')
            that.getData()
          }else{
            that.$message.error('操作失败')
          }
        })
      },
      findParents(id,pid,treeData){
        if(!treeData||treeData.length==0) return
        for(let i=0;i<treeData.length;i++){
          if(treeData[i][pid] == id){
            return [id]
          }else{
            if(treeData[i].treeList){
              let res = this.findParents(id,pid,treeData[i].treeList)
              if(res !== undefined){
                return res.concat(treeData[i].id)
              }
            }
          }
        }
      },
    }
  }
  </script>
<style scoped>
  .box-second .main{
    height: calc(100% - 38px);
  }
  .main-left{
      width: 15vw;
      height: 100%;
      position: relative;
      overflow: auto;
      background: #fff;
      border-radius: 0.5vh;
      padding: 2vh;
  }
  .main-table{
      width: calc( 100% - 15vw );
      height: 100%;
      position: relative;
      padding-left: 1vw;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
  }
  .table-head{
      width: 100%;
      /* height: 10vh; */
      position: relative;
      background: #fff;
      border-top-left-radius: 0.5vh;
      border-top-right-radius: 0.5vh;
      display: flex;
      flex-direction: column;
      align-content: center;
      align-items: center;
      padding: 2vh;
      /* justify-content: space-between; */
      background: #FAFAFA;
  }
  .table-head-seach{
      width: 10%;
      height: 100%;
      position: relative;
  }
  .table-box{
      width: 100%;
      height: calc( 100% - 14vh );
      position: relative;
      background: #fff;
      border-bottom-left-radius: 0.5vh;
      border-bottom-right-radius: 0.5vh;
      margin-top: 0.5vh;
  }
 .box-second  >>>.el-date-editor .el-range-separator{
    padding: 0 !important;
  }
  .box-second >>>.el-input-group--append .el-input__inner{
    width: 200px;
  }
  .tips{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
   }
</style>
<style>
@import '../../assets/css/common.css'
</style>